import { NgModule, ApplicationRef } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { removeNgStyles, createNewHosts } from '@angularclass/hmr';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

// Custom modules
import { SharedModule } from '../modules/shared/shared.module';
import { LoginModule } from '../modules/login/login.module';
import { ReservationModule } from '../modules/reservation/reservation.module';
import { ManagementModule } from '../modules/management/management.module';

// Routes
import { AppRouting, appRoutingProviders } from '../routes/app.routes';
import { AuthGuard } from '../routes/auth-guard';
import { AdHocAuthGuard } from '../routes/ad-hoc-auth-guard';
import { ConditionsAuthGuard } from '../routes/conditions-auth-guard';

// Container components
import { AppComponent } from '../components/app.component';

// Reducers, store and state
import { rootReducers, metaReducers } from '../store/root.reducer';
import { InitialState } from '../store/initial-state';

// Services
import { LocaleService } from '../services';

// SCSS
import '../../scss/main.scss';

// Creates the API base url for use throughout the application
export const _API_BASE_URL_ = (() => {
	const hostname = window.location.hostname;
	switch (hostname) {
		case 'localhost':
			return window.location.protocol + '//localhost:3000/api/';
		case 'waddinxveen.nautaconnect.cloud':
			return window.location.protocol + '//api-waddinxveen.nautaconnect.cloud/api/';
		case 'ctp-eu-euw-wddnxvn-wa-app.azurewebsites.net':
			return window.location.protocol + '//ctp-eu-euw-wddnxvn-wa-api.azurewebsites.net/api/';
		case 'nc-eu-euw-wddnxvnprd-wa-app.azurewebsites.net':
			return window.location.protocol + '//nc-eu-euw-wddnxvnprd-wa-api.azurewebsites.net/api/';
		case 'azure-waddinxveen.nautaconnect.cloud':
			return window.location.protocol + '//api-azure-waddinxveen.nautaconnect.cloud/api/';
		default:
			return `${process.env.API}api/`;
	}
})();

// Creates the recipe images base url for use throughout the application
export const _IMG_BASE_URL_ = (
	process.env.ENV === 'build' ? '/images/products/' : process.env.HOST + 'images/products/'
);

@NgModule({
	imports: [
		BrowserModule,
		HttpClientModule,
		HttpModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (http: HttpClient) => new TranslateHttpLoader(http, '/i18n/', '.json'),
				deps: [HttpClient]
			}
		}),
		AppRouting,
		StoreModule.forRoot(
			rootReducers, {
				initialState: InitialState,
				metaReducers: metaReducers
			}
		),
		StoreDevtoolsModule.instrument({
			maxAge: 5
		}),
		SharedModule,
		LoginModule,
		ReservationModule,
		ManagementModule
	],
	declarations: [
		AppComponent
	],
	providers: [
		{ provide: APP_BASE_HREF, useValue: '/' },
		[
			{ provide: 'ApiEndpoint', useValue: _API_BASE_URL_ },
			{ provide: 'ImagesUrl', useValue: _IMG_BASE_URL_ }
		],
		appRoutingProviders,
		AuthGuard,
		AdHocAuthGuard,
		ConditionsAuthGuard,
		LocaleService
	],
	bootstrap: [AppComponent]
})

export class AppModule {
	constructor(public appRef: ApplicationRef) { }

	hmrOnInit(store) {
		console.log('HMR store', store);
	}

	hmrOnDestroy(store) {
		let cmpLocation = this.appRef.components
			.map(cmp => cmp.location.nativeElement);

		// Recreates elements
		store.disposeOldHosts = createNewHosts(cmpLocation);

		// Removes styles
		removeNgStyles();
	}

	hmrAfterDestroy(store) {

		// Displays new elements
		store.disposeOldHosts();
		delete store.disposeOldHosts;
	}
}
